export default {
  props: {
    contacts: {
      type: [Object, Array],
      required: false,
      default: null
    }
  }
}
